import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReachabilityCard',
  setup(__props) {

const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

const openingEndTime = computed(() => {
  const currentDay = days[new Date().getDay()]
  const availability = store.state.settings.openingTimes[currentDay]
  return availability.end_time
})

const phoneNumber = computed(()=> store.state.settings.phoneNumber)

return { __sfc: true,days, openingEndTime, phoneNumber }
}

})